import { useEffect } from "react";

interface NavbarDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  isBottomBarVisible: boolean;
  children: React.ReactNode;
}

const NavbarDrawer = ({
  isOpen,
  onClose,
  isBottomBarVisible,
  children,
}: NavbarDrawerProps) => {
  // Function to add/remove 'overflow-hidden' class from the body
  const toggleBodyOverflow = (isOpen: boolean) => {
    const body = document.querySelector("body");
    if (body) {
      body.classList.toggle("overflow-hidden", isOpen);
    }
  };

  useEffect(() => {
    toggleBodyOverflow(isOpen); // Call the function when the drawer opens/closes
    return () => toggleBodyOverflow(false); // Reset body overflow when component unmounts
  }, [isOpen]);

  return (
    <div className="block lg:hidden">
      {/* Background overlay */}
      {isOpen && (
        <div
          className={`fixed inset-0 z-50 ${isBottomBarVisible && "mb-[96px]"} mt-[55px] bg-black opacity-80 sm:mt-[80px] lg:mb-0`}
          onClick={onClose} // Close the drawer when clicking on the background overlay
        ></div>
      )}
      {/* Drawer content */}
      <div
        className={`fixed ${isBottomBarVisible ? "bottom-[96px]" : "bottom-[2px]"} left-0 top-[55px] z-50 transform border border-white/10 transition-transform sm:top-[80px] lg:bottom-0 ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
        style={{ width: "280px" }} // Adjust width as needed
      >
        {/* Drawer body */}
        <div className="h-full">{children}</div>
      </div>
    </div>
  );
};

export default NavbarDrawer;
